import React from 'react'
import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import BusinessController from '../assets/portfolio/Business Controller.png'
import BusinessPartner from '../assets/portfolio/Business Partner.png'



const Services = () => {
    const services = [
        {
            id: 1,
            title: "Business Controller",
            description: "Financial transparency for current operations",
            src: BusinessController,
            path: '/business-controller'
        },
        {
            id: 2,
            title: "Business Partner",
            description: "Collaborative support for growth operational projects",
            src: BusinessPartner,
            path: '/business-partner'
        },
    ]

    return (
        <motion.div 
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 3 }} // Slower fade-in of the entire section
            name='Services' 
            className='bg-gradient-to-b from-white to-white w-full text-black min-h-screen py-32 mt-96 mb-32 sm:mb-0 sm:mt-0 sm:py-20'
        >
            <div className='max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full'>
                <motion.div 
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 1.2, ease: "easeOut" }}
                    className='pb-16 text-center'
                >
                    <h2 className='text-4xl font-bold inline border-b-4 border-black'>Services</h2>
                    <motion.p
                        initial={{ opacity: 0, y: 10 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 1.2, delay: 0.2, ease: "easeOut" }}
                        className='mt-6 text-lg max-w-2xl mx-auto text-black'
                    >
                        Specialized financial knowledge, combining expertise, technology and a hands-on mindset to drive growth and efficiency. 
                    </motion.p>
                </motion.div>

                <div className='flex justify-center w-full'>
                    <div className='grid grid-cols-1 md:grid-cols-2 gap-16 px-4 sm:px-0 mb-16 sm:mb-0 max-w-4xl mx-auto'>
                        {services.map(({id, title, description, src, path}, index) => (
                            <motion.div 
                                key={id}
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 2, delay: index * 2 }} // Slower animation with more delay
                                className='flex flex-col items-center'
                            >
                                {/* Image section - no background */}
                                <Link 
                                    to={path}
                                    onClick={() => window.scrollTo(0, 0)}
                                    className="w-full mb-6" // Added margin below image
                                >
                                    <div className="rounded-lg overflow-hidden transition-all duration-500">
                                        <img 
                                            src={src} 
                                            alt={title} 
                                            className='w-full h-48 object-contain transition-transform duration-1000' 
                                        />
                                    </div>
                                </Link>
                                
                                {/* Text section - separate from image */}
                                <div className="text-center">
                                    <h3 className="text-2xl font-semibold mb-3">{title}</h3>
                                    <p className="text-gray-600 mb-4">{description}</p>
                                    <Link 
                                        to={path}
                                        onClick={() => window.scrollTo(0, 0)}
                                    >
                                        <span className="inline-block px-5 py-2 bg-gray-100 hover:bg-gray-200 rounded-md text-black font-medium transition-colors duration-500">
                                            Learn More
                                        </span>
                                    </Link>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </div>
        </motion.div>
    )
}

export default Services
